const billingHelpers = require('./billing/helpers');
const giftCardHelpers = require('./billing/giftCardHelpers');
const moneyUtils = require('../common/utils/moneyUtils');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const installmentHelpers = require('../adyen/checkout/installments');

const FRONT_CONFIG = getFrontConfig();
const { paymentMethods } = FRONT_CONFIG.checkout;

/**
 * If the site Tax Policy is NET
 * and the order has taxes,
 * updates tax messages
 * @param {string} totalTax - the total tax amount formatted as price string
 */
function updateTaxMessages(totalTax) {
  const { isTaxPolicyNet } = FRONT_CONFIG;
  const taxes = moneyUtils.getNumericValue(totalTax);

  if (isTaxPolicyNet && taxes === null) {
    $('.tax-total-container')?.addClass('d-none');
    $('.grand-total-container__taxMsg')?.removeClass('d-none');

    // Update checkout tax message above Payment form
    $('.payment-form__tax-message')?.addClass('d-none');
  } else if (isTaxPolicyNet) {
    const taxTotalPrice = $('.tax-total-container__price');
    if (taxTotalPrice.length > 0) {
      taxTotalPrice.html(totalTax);
    }

    $('.tax-total-container')?.removeClass('d-none');
    $('.grand-total-container__taxMsg')?.addClass('d-none');

    // Update checkout tax message above Payment form
    const paymentFormTaxInfoMessage = document.querySelector(
      '.payment-form__tax-message'
    );
    if (paymentFormTaxInfoMessage) {
      paymentFormTaxInfoMessage.classList.remove('d-none');
      paymentFormTaxInfoMessage.querySelector(
        '.tax-info-message__total'
      ).innerHTML = totalTax;
    }
  }
}

/**
 * Updates checkout summary promotions row for given container
 * @param {JQuery} container - promotions container
 * @param {Object[]} promotions - promotions data
 * @param {string} promotions.name - promotion name
 * @param {Object} promotions.basePrice - promotion base price
 * @param {string} promotions.basePrice.formatted - promotion formatted base price
 */
function updatePromotions(container, promotions) {
  container.empty();
  promotions.forEach((item) => {
    // Main container
    const rowDiscount = document.createElement('div');
    rowDiscount.classList.add(
      'row',
      'leading-lines',
      'order-discount',
      'totals__total'
    );

    // Promo naming
    const nameRowDiscountContainer = document.createElement('div');
    nameRowDiscountContainer.classList.add('start-lines');
    const nameRowDiscountParagraph = document.createElement('p');
    nameRowDiscountParagraph.classList.add('order-receipt-label');
    nameRowDiscountParagraph.innerHTML = `<span>${item.name}</span>`;
    nameRowDiscountContainer.append(nameRowDiscountParagraph);
    rowDiscount.append(nameRowDiscountContainer);

    // discount total amount
    const valueRowDiscountContainer = document.createElement('div');
    valueRowDiscountContainer.classList.add('end-lines');
    const valueRowDiscountParagraph = document.createElement('p');
    valueRowDiscountParagraph.classList.add('order-receipt-value');
    const spanRowDiscountParagraph = document.createElement('span');
    spanRowDiscountParagraph.classList.add(
      'order-discount-total',
      'price-currency'
    );
    spanRowDiscountParagraph.textContent = `- ${item.basePrice.formatted}`;
    valueRowDiscountParagraph.append(spanRowDiscountParagraph);
    valueRowDiscountContainer.append(valueRowDiscountParagraph);
    rowDiscount.append(valueRowDiscountContainer);

    container.append(rowDiscount);
  });
}

/**
 * Updates the productLineItems & shippingn promotion rows in cart totals
 * @param {Object} totals - Cart totals object
 * @param {Object} totals.appliedPromotions - Cart productLineItem applied promotions object
 * @param {Object} totals.shippingAppliedPromotions - Cart shipping applied promotions object
 */
function updatePromotionRows(totals) {
  const productLineItemsPromotionsContainer = $(
    '.promotion-discount-container'
  );
  updatePromotions(
    productLineItemsPromotionsContainer,
    totals.appliedPromotions
  );
  const shippingPromotionsContainer = $(
    '.promotion-discount-container--shipping'
  );
  updatePromotions(
    shippingPromotionsContainer,
    totals.shippingAppliedPromotions
  );
}

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
  const $totalsBlock = $('.totals');
  const $grandTotalContainers = $('.grand-total-container');
  const previousGrandTotal = $('.grand-total', $grandTotalContainers).attr(
    'data-value'
  );
  const isGiftCardSelected = billingHelpers.methods.isGiftCardSelected();
  const displayTotals = isGiftCardSelected
    ? giftCardHelpers.methods.adjustTotalsForGiftCard(totals)
    : totals;

  $('.shipping-cost', $totalsBlock).text(displayTotals.totalShippingCost);
  const deliveryTotalEl = document.querySelector(
    '.order-summary .delivery-total-container .price-currency'
  );
  if (deliveryTotalEl) {
    deliveryTotalEl.textContent = displayTotals.totalShippingCost;
  }
  $('.sub-total', $totalsBlock).text(displayTotals.subTotal);

  const giftCardTotalContainers = document.querySelectorAll(
    '.gift-card-total-container'
  );
  giftCardTotalContainers.forEach((giftCardTotalContainer) => {
    if (
      !displayTotals.spentGiftCardTotal ||
      displayTotals.spentGiftCardTotal === ''
    ) {
      giftCardTotalContainer.classList.add('d-none');
    } else {
      // eslint-disable-next-line no-param-reassign
      giftCardTotalContainer.querySelector(
        '.gift-card-total-container__price'
      ).innerHTML = displayTotals.spentGiftCardTotal;
      giftCardTotalContainer.classList.remove('d-none');
    }
  });

  const grandTotalValue =
    displayTotals.grandTotal && displayTotals.grandTotal !== '-'
      ? displayTotals.grandTotal
      : displayTotals.netGrandTotal;

  // Also update mobile checkout summary header
  $('.grand-total', $grandTotalContainers)
    .text(grandTotalValue)
    .attr('data-value', displayTotals.floatTotal);

  const summaryGrandTotalContainerEl = document.querySelector(
    '.grand-total-container .price-currency'
  );
  if (summaryGrandTotalContainerEl) {
    summaryGrandTotalContainerEl.textContent = grandTotalValue;
  }

  updatePromotionRows(totals);

  if (totals.grandTotal !== previousGrandTotal) {
    installmentHelpers.updateInstallmentOptions();
  }

  updateTaxMessages(totals.totalTax);
}

/**
 * Updates the order products summary for an order model
 * ignores the update when order and dom elements quantity are the same
 * @param {Order} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
  const domProductsLength = document.querySelectorAll(
    '.cart-content__product-container .product-card'
  ).length;
  if (order.items.totalQuantity === domProductsLength) {
    return;
  }

  const $productSummary = $('<div />');

  order.shipping.forEach((shipping) => {
    shipping.productLineItems.items.forEach((lineItem) => {
      const productLineItemElement = $(`[data-uuid=${lineItem.UUID}]`);
      $productSummary.append(productLineItemElement);
    });
  });

  const $aproachingDiscount = $('.approaching-discounts');
  $productSummary.append($aproachingDiscount);

  $('.cart-content__product-container').html($productSummary.html());

  const numberOfItemsElement = document.querySelector('.number-of-items');
  if (numberOfItemsElement) {
    const newNumberOfItemsContent = numberOfItemsElement.textContent.replace(
      /\d+/,
      order.items.totalQuantity
    );
    numberOfItemsElement.textContent = newNumberOfItemsContent;
  }
}

/**
 * Updates the Adyen installments information in checkout summary
 */
function updateSummaryAdyenInstallments() {
  const $paymentSummary = $('.payment-details');
  if (window.AdyenInstallmentsEnabled && window.AdyenInstallmentsOptions) {
    let cardInstallments = null;
    const selectedCardInput = $('input[name="brandCode"]:checked');
    const isNewCardSelected = selectedCardInput.val().indexOf('scheme') !== -1;
    const isStoredCardSelected =
      selectedCardInput.val().indexOf('storedCard') !== -1;
    if (isNewCardSelected) {
      cardInstallments = $('#adyen-new-card-installments select').val();
    } else if (isStoredCardSelected) {
      cardInstallments = selectedCardInput
        .closest('li')
        .find('.adyen-checkout__custominstallments select')
        .val();
    }
    const cardInstallmentsContainer = $paymentSummary
      .find('.credit-card-installments')
      .clone();
    if (
      cardInstallmentsContainer.length > 0 &&
      cardInstallments &&
      parseInt(cardInstallments, 10) > 1
    ) {
      const installmentsText = cardInstallmentsContainer
        .text()
        .replace('{0}', cardInstallments);
      $paymentSummary.append(
        cardInstallmentsContainer.text(installmentsText).removeClass('d-none')
      );
    }
  }
}

/**
 * Fills the gift card payment summary details
 */
function fillGiftCardSummaryDetails() {
  const giftCardTabElement = document.querySelector(
    `.payment-options [data-method-id="${paymentMethods.GIFT_CARD}"] .nav-link`
  );

  const wrapper = document.createElement('div');
  wrapper.classList.add(
    'gift-card-payment-details',
    'payment-info-summary__text'
  );

  const titleContainer = document.createElement('div');
  titleContainer.classList.add(
    'payment-details-content',
    'payment-info-summary__container'
  );
  Array.from(giftCardTabElement.children).forEach((child) => {
    titleContainer.appendChild(child.cloneNode(true));
  });
  wrapper.appendChild(titleContainer);

  const { formattedRemainingBalance, spentGiftCardTotal } =
    giftCardHelpers.methods.getGiftCardResponseDataFromDOM();

  if (spentGiftCardTotal) {
    const spentAmountLabel = giftCardTabElement.dataset.spentAmountLabel || '';
    const spentAmountP = document.createElement('p');
    spentAmountP.classList.add('gift-card-payment-details__spent-amount');
    spentAmountP.textContent = `${spentAmountLabel} `;
    const spentAmountSpan = document.createElement('span');
    spentAmountSpan.classList.add(
      'gift-card-payment-details__spent-amount-value'
    );
    spentAmountSpan.innerHTML = spentGiftCardTotal;
    spentAmountP.appendChild(spentAmountSpan);
    wrapper.appendChild(spentAmountP);
  }

  if (formattedRemainingBalance) {
    const remainingBalanceLabel =
      giftCardTabElement.dataset.remainingBalanceLabel || '';
    const remainingBalanceP = document.createElement('p');
    remainingBalanceP.classList.add(
      'gift-card-payment-details__remaining-balance'
    );
    remainingBalanceP.textContent = `${remainingBalanceLabel} `;
    const remainingBalanceSpan = document.createElement('span');
    remainingBalanceSpan.classList.add(
      'gift-card-payment-details__remaining-balance-value'
    );
    remainingBalanceSpan.innerHTML = formattedRemainingBalance;
    remainingBalanceP.appendChild(remainingBalanceSpan);
    wrapper.appendChild(remainingBalanceP);
  }

  document.querySelector('.payment-details').appendChild(wrapper);
}

/**
 * Fills the payment summary details based on the selected payment method
 * @param {string} selectedPaymentMethod - The selected payment method name
 */
function fillPaymentSummaryDetails(selectedPaymentMethod) {
  const paymentMethodTabElement = document.querySelector(
    `.payment-options .nav-item[data-method-id="${selectedPaymentMethod}"] .nav-link`
  );
  const clonedTemplate = document.createElement('div');
  clonedTemplate.classList.add('payment-details-content');
  Array.from(paymentMethodTabElement.children).forEach((child) => {
    clonedTemplate.appendChild(child.cloneNode(true));
  });

  document.querySelector('.payment-details').appendChild(clonedTemplate);
}

/**
 * Gets the masked card number from the currently selected stored card.
 * @returns {string} the masked card number or empty string
 */
function getSelectedStoredCardMaskedNumber() {
  const selectedMethod = document.querySelector(
    'input[name="brandCode"]:checked'
  );
  return selectedMethod?.dataset.maskedNumber || '';
}

/**
 * Updates the Adyen payment information in checkout summary
 */
function updateAdyenPaymentSummary() {
  const paymentSummary = document.querySelector('.payment-details');
  const creditCardNumberElement = paymentSummary?.querySelector(
    '.credit-card-number'
  );
  const maskedNumber =
    document.getElementById('cardNumber')?.value ||
    getSelectedStoredCardMaskedNumber();

  if (creditCardNumberElement && maskedNumber) {
    const creditCardNumber = creditCardNumberElement.cloneNode(true);
    creditCardNumber.textContent = maskedNumber;
    creditCardNumber.classList.remove('d-none');
    paymentSummary.appendChild(creditCardNumber);
  }
  updateSummaryAdyenInstallments();
}

/**
 * Updates the payment information in checkout summary
 */
function updatePaymentSummary() {
  const paymentDetailsElement = document.querySelector('.payment-details');
  paymentDetailsElement.innerHTML = '';

  const selectedPaymentMethods =
    billingHelpers.methods.getSelectedPaymentMethodIds();
  selectedPaymentMethods.forEach((selectedPaymentMethod) => {
    if (selectedPaymentMethod === paymentMethods.GIFT_CARD) {
      fillGiftCardSummaryDetails();
    } else if (selectedPaymentMethod === paymentMethods.AdyenComponent) {
      fillPaymentSummaryDetails(selectedPaymentMethod);
      updateAdyenPaymentSummary();
    } else {
      fillPaymentSummaryDetails(selectedPaymentMethod);
    }
  });
}

module.exports = {
  methods: {
    updatePaymentSummary,
  },
  updateOrderProductSummaryInformation,
  updateTaxMessages,
  updateTotals,
};
